import {AbstractControl, ValidatorFn} from '@angular/forms';

import {NotNullArrayValuesValidatorKey} from './custom-validator-keys';

export function NotNullArrayValuesValidator(): ValidatorFn {
    return (control: AbstractControl): { [NotNullArrayValuesValidatorKey]: boolean } | null => {
        if (control.value && Array.isArray(control.value)) {
            return (control.value.filter((item: number | string) => item !== null).length > 0) ? null :
                {[NotNullArrayValuesValidatorKey]: true};
        }

        return null;
    };
}
